import script from "./Feature.vue?vue&type=script&setup=true&lang=js"
export * from "./Feature.vue?vue&type=script&setup=true&lang=js"

import "./Feature.vue?vue&type=style&index=0&id=a2778d40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2778d40"]])

export default __exports__